import React from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useAlertQuery from '../hooks/useAlertQuery';
import getFormTitle from '#/common/utils/getFormTitle';
import AlertRecordPreview from '../components/AlertRecordPreview';

export interface AlertParams {
  readonly id?: string;
}

const AlertPage: React.FC = () => {
  const { id } = useParams() as AlertParams;
  const alertQuery = useAlertQuery(id);
  const alert = alertQuery.data?.getAlert?.data;

  const displayNumber = alert?.displayNumber;
  const title = getFormTitle(id, displayNumber, 'Alert');

  return (
    <SubPage title={title} isLoading={alertQuery.loading} showGoBackButton type="form">
      {alert && <AlertRecordPreview alert={alert || {}} />}
    </SubPage>
  );
};

export default React.memo(AlertPage);
